$(document).ready(function(event){
  initCalendars();

  $('#form').on('click', '.change-tab-btn', function(){
    var obj = this;
    var step = $(this).data('step');
    var nextStep = $(this).data('next-step');
    var isFinish = $(this).data('finish');
    var tourObjectId = $('#Offer_tour_object_id').val();
    var currentStep = $('#steps > li.active').data('current-step');

    $('#offer-form').ajaxSubmit({
      dataType: 'json',
      url: '/offer/validate/?tourObjectId=' + tourObjectId + '&step=' + step + '&currentStep' + currentStep,
      success: function(response) {
        replaceForm(response.form, function() {
          $('#discount-percent').html(response.discount);
          $('#discount-terms').html(response.terms);

          if( ! response.hasErrors) {
            if( ! isFinish) {
              $('.step-block a[href="' + nextStep + '"]').tab('show');
              updateDiscount();
            } else {
              $('#form form').submit();
            }
          }
        });
      }
    });
  });

  $('#form').on('change', 'input:not(".i-check")', updateDiscount);

  $('#form').on('ifChanged', 'input[type="checkbox"].i-check', updateDiscount);

  $('#form').on('ifChecked', 'input[type="radio"].i-check', updateDiscount);

  $('#form').on('click', '.prev-tab-btn', function() {
    var step = $(this).data('step');
    $('.step-block a[href="' + step + '"]').tab('show');
  });

  $('#form').on('change', '#Offer_begin_date, #Offer_end_date, #Offer_birth_date', function() {
    $(this).datepicker('hide');
  });

  $('#form').on('change', '#Offer_begin_date', function() {
    normalizeDateInputs($(this), $('#Offer_end_date'));
  });

  $('#form').on('click', '.step-block a', function(e) {
    e.preventDefault();
    return false;
  });

  $('#form').on('click', '.form-control-feedback', function() {
    $(this).prev().focus();
  });

  $('#form').on('ifChanged', '.hasSub', function() {
    var target = $(this).data('target');
    var $target = $('#' + target);

    if($(this).is(':checked')) {
      $target.show();

      var countChecked = $target.find('input:checked').not(':disabled').length;
      if(countChecked <= 0) {
        $target.find('input:first').not(':disabled').iCheck('check');
      }
    } else {
      $target.hide();
    }
  });
});

function initStep2() {
  $('.hasSub').each(function() {
    var target = $(this).data('target');
    var $target = $('#' + target);

    if($(this).is(':checked')) {
      $target.show();

      var countChecked = $target.find('input:checked').not(':disabled').length;
      if(countChecked <= 0) {
        $target.find('input:first').not(':disabled').iCheck('check');
      }
    } else {
      if( ! $target.hasClass('visible')) {
        $target.hide();
      }
    }
  });
}

function replaceForm(html, callback) {
  $('#form').html(html).promise().done(callback);

  initCalendars();
  initPhoneMask();
  initCheckbox();
}

function updateDiscount() {
  var currentStep = $('#steps > li.active').data('current-step');

  $('#offer-form').ajaxSubmit({
    dataType: 'json',
    url: '/offer/calculateDiscount?currentStep=' + currentStep,
    success: function(response) {
      $('#discount-terms').html(response.terms);
      initStep2();
    }
  });
}

function initCheckbox() {
  $('.i-check, .i-radio').iCheck({
    checkboxClass: 'i-check',
    radioClass: 'i-radio'
  });
}

function initPhoneMask() {
  $(".phoneMask").inputmask("+7 (999) 999-99-99");
}

function initCalendars() {
  $('.datepicker').each(function(){

    var $calendar = $(this);
    $calendar.inputmask("d.m.y", { "placeholder": "дд.мм.гггг" });

    if($(this).is('.set-start-date')){
      $($calendar).datepicker({
        format: 'dd.mm.yyyy',
        language: 'ru',
        startDate: new Date()
      }).bind("keydown", function (e) {
        $calendar.datepicker('hide');
      });
    }else{
      $($calendar).datepicker({
        format: 'dd.mm.yyyy',
        language: 'ru'
      }).bind("keydown", function (e) {
        $calendar.datepicker('hide');
      });
    }
  });
}

function normalizeDateInputs($begin, $end){
  var start = $begin.datepicker('getDate');
  var minEnd = new Date(start.getTime() + 3600 * 24 * 1000);
  var end = $end.datepicker('getDate');
  if(start >= end) {
    $end.datepicker('setDate', minEnd);
  }
  $end.datepicker('setStartDate', minEnd);
}

function changeTab(obj) {
  // Процесс смены шага
  var target = $(obj).attr('href');

  $('.step-block').removeClass('active');
  $('#steps').find('a[href="' + target + '"]').closest('.step-block').addClass('active');
}